export function getNewScrollPercentage() {
  function getYValue(isCSS1Compat, supportPageOffset) {
    if (supportPageOffset) {
      return window.pageYOffset;
    } else {
      if (isCSS1Compat) {
        return document.documentElement.scrollTop;
      } else {
        return document.body.scrollTop;
      }
    }
  }

  function calculateScrollTopPercentage(scrollYValue) {
    const actualScrollHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    return (scrollYValue / actualScrollHeight) * 100;
  }

  const supportPageOffset = window.pageXOffset !== undefined;
  const isCSS1Compat = (document.compatMode || "") === "CSS1Compat";

  const percentageCalculated = calculateScrollTopPercentage(
    getYValue(isCSS1Compat, supportPageOffset)
  );
  return percentageCalculated;
}

export function appendUserSnapTestingScript(usersnap) {
  if (usersnap) {
    // User snap testing script
    // ------------------------
    window.onUsersnapCXLoad = function (api) {
      api.init();
    };
    const script = document.createElement("script");
    script.text = `(function() { 
        var s = document.createElement("script"); 
        s.type = "text/javascript"; 
        s.async = true; 
        s.src = "${usersnap}";
        document.getElementsByTagName('head')[0].appendChild(s);
      })()`;
    document.body.appendChild(script);
  }
}

let throttleTimer = null;
export function throttle(callback) {
  if (throttleTimer) {
    throttleTimer = null;
  }
  throttleTimer = setTimeout(callback, 15);
}

export function getMaxScrollHeight() {
  return Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  );
}

export function getScrollParams(currentPoint) {
  const startPoint = window.pageYOffset || document.documentElement.scrollTop;
  const scrollDifference = currentPoint - startPoint;
  const signedScrollDifference =
    scrollDifference > 0 ? scrollDifference : -scrollDifference;
  const duration = (signedScrollDifference / 25) * 10;
  return {
    start: startPoint,
    change: scrollDifference,
    currentTime: 0,
    increment: 20,
    duration,
  };
}
